export class BenefitProducts {
    constructor(public id: number, public title: string, public description: string, public icon: string){}
}